module.exports = __webpack_public_path__ + "static/img/main3-bg.b790939.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/main3-bg.png
// module id = jAXS
// module chunks = 7